import { render, staticRenderFns } from "./RelatorioAlarmes.vue?vue&type=template&id=81ea8ca8&scoped=true"
import script from "./RelatorioAlarmes.vue?vue&type=script&lang=js"
export * from "./RelatorioAlarmes.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAlarmes.vue?vue&type=style&index=0&id=81ea8ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ea8ca8",
  null
  
)

export default component.exports